function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "a",
  d: "M.03.023h20.64v21.966H.03z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "#8EA907",
  d: "M14.668 10.46a11.728 11.728 0 00-1.295-.075H0v13.373c0 6.415 5.2 11.616 11.616 11.616h13.372l-9.456-9.456c-4.226-4.227-4.513-10.898-.864-15.459"
}), React.createElement("path", {
  fill: "#6D9D14",
  d: "M36.604 10.385c-.438 0-.87.027-1.296.074 3.65 4.56 3.363 11.232-.864 15.459l-9.456 9.456h13.373c6.415 0 11.616-5.2 11.616-11.616V10.385H36.604z"
}), React.createElement("g", {
  transform: "translate(14.638 .012)"
}, React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#a"
})), React.createElement("path", {
  fill: "#BAC516",
  d: "M10.35 21.989c0-5.977 4.515-10.898 10.32-11.542a11.74 11.74 0 00-.864-.968L10.35.023.894 9.479c-.31.31-.597.634-.864.968",
  mask: "url(#b)"
})), React.createElement("path", {
  fill: "#436C03",
  d: "M14.668 10.46c-3.649 4.56-3.362 11.231.864 15.458l9.456 9.456V22c0-5.977-4.515-10.897-10.32-11.542"
}), React.createElement("path", {
  fill: "#1A4108",
  d: "M35.308 10.46c-5.805.644-10.32 5.564-10.32 11.541v13.373l9.456-9.456c4.227-4.227 4.513-10.898.864-15.459"
}));

var SvgIconLogo = function SvgIconLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 50 36",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-logo.fa8d5936.svg";
export { ForwardRef as ReactComponent };